import React, { useEffect } from 'react';
import { size, sortBy } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { Field } from 'redux-form';
import { TableSelect } from '../ChargersTableComponents';
import { allMenuItem, getMenuItemsFromDictValues } from '../../../../common/components/CommonTableColumns';
import RenderSelect from '../../../../common/components/Form/RenderSelect';
import MenuItem from '../../../../common/components/MenuItem/MenuItem';

const getCountryOptions = (values) => {
  const countries = [allMenuItem];

  countries.push(
    values.map((item) => (
      <MenuItem key={uuidv4()} value={item.value} title={item.label}>
        {item.label}
      </MenuItem>
    )),
  );

  return countries;
};

export default function ({ countries, initCounrtyList, value, onChange, field }) {
  useEffect(() => {
    if (!size(countries)) {
      initCounrtyList();
    }
  }, []);

  const { required, name, readOnly, validate, className, isRenderSelectMode, floatingLabelText, floatingLabelStyle, clearable } =
    field ?? {};
  const countryList = sortBy(getMenuItemsFromDictValues(countries), (country) => country.label);

  return isRenderSelectMode ? (
    <Field
      required={required}
      key={name}
      name={name}
      readOnly={readOnly}
      className={className}
      component={RenderSelect}
      options={countryList}
      floatingLabelText={floatingLabelText}
      validate={validate}
      floatingLabelStyle={floatingLabelStyle}
      clearable={clearable}
      fullWidth
    />
  ) : (
    <TableSelect options={getCountryOptions(countryList)} onChange={onChange} value={value} />
  );
}
